import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import Layout from "./Layout";
const NoPageFound = () => {
  return (
    <Layout>
      <div>
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Button type="primary" shape="round">
              <Link to="/app">Back Home</Link>
            </Button>
          }
        />
      </div>
    </Layout>
  );
};

export default NoPageFound;
